import "./styles.scss";
import PropTypes from "prop-types";
import React from "react";

import {
  createClassNameString,
  formatSoftPaywallExpirationTimestamp,
  formatTimestamp,
} from "../utils";
import { ErrorCard } from "../ErrorCard";
import { Text } from "../Text/Text";
import { TextTypes, TextColors } from "../constants";

export const PatientChartPaymentBanner = ({
  className,
  patientName,
  paywallType,
  softPaywallTimestamp,
  lastFailedTransactionTimestamp,
}) => {
  const renderBannerContent = () => {
    switch (paywallType) {
      case "soft_paywall": {
        const hasNotSeenSoftPaywall =
          "needs to update their payment method soon to avoid any disruption to care.";
        const hasSeenSoftPaywall = (
          <>
            has until{" "}
            <span data-private>{formatSoftPaywallExpirationTimestamp(softPaywallTimestamp)}</span>{" "}
            to update their payment method.
          </>
        );

        return (
          <Text
            data-public
            type={TextTypes.label}
            color={TextColors.red}
            testId={
              softPaywallTimestamp
                ? "soft-paywall-banner-timestamp"
                : "soft-paywall-banner-no-timestamp"
            }
          >
            Patient action needed: <span data-private>{patientName}</span>{" "}
            {softPaywallTimestamp ? hasSeenSoftPaywall : hasNotSeenSoftPaywall} They can still
            access the platform and attend sessions until then.
          </Text>
        );
      }

      case "hard_paywall_add_payment": {
        return (
          <Text
            data-public
            type={TextTypes.label}
            color={TextColors.red}
            testId="hard-paywall-banner-add-payment"
          >
            Patient access blocked: <span data-private>{patientName}</span> did not update their
            payment method within 24 hours and is now locked out of the platform. Do not schedule or
            hold sessions until access is restored.
          </Text>
        );
      }

      case "hard_paywall_update_payment": {
        return (
          <Text
            data-public
            type={TextTypes.label}
            color={TextColors.red}
            testId="hard-paywall-banner-update-payment"
          >
            Patient access blocked due to failed payment: A charge attempt on{" "}
            <span data-private>{formatTimestamp(lastFailedTransactionTimestamp)}</span> was
            unsuccessful. <span data-private>{patientName}</span> is locked out of the platform and
            must update their payment method to resume care.
          </Text>
        );
      }
    }
  };

  return (
    <ErrorCard className={createClassNameString(["PatientChartPaymentBanner-banner", className])}>
      {renderBannerContent()}
    </ErrorCard>
  );
};

PatientChartPaymentBanner.propTypes = {
  className: PropTypes.string,
  patientName: PropTypes.string.isRequired,
  bannerType: PropTypes.oneOf(["softPaywall", "hardPaywall", "failedTransaction"]),
  graceEndTime: PropTypes.string,
  failedTransactionDate: PropTypes.string,
};
